import { Component, OnInit, Input } from '@angular/core';
import { OrgAddOrganization } from './model/organization';
import { OrgaddService } from './service/orgadd.service';
import { Router } from '@angular/router';
import { SessionHelper } from '@src/app/helpers/sessionHelper';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-orgadd',
  templateUrl: './orgadd.component.html',
  styleUrls: ['./orgadd.component.css']
})
export class OrgaddComponent implements OnInit {
 @Input() modalmode:boolean;
 @Input() organization:OrgAddOrganization;
  constructor(
    private orgaddservice:OrgaddService,
    private router: Router,
  ) { }

  ngOnInit() {
    var currentperson = JSON.parse(SessionHelper.getPerson());
    this.organization = {
      organizationId: "",
      organizationname: "",
      orgdesc: "",
      www: "",
      email:"",
      address: "",
      address2: "",
      zip: "",
      city: "",
      country: "",
      logourl: "",
      creator: currentperson.fullname,
      creatorId: SessionHelper.getUserSub(),
      modules: "",
      member_member_function: "Not assigned yet",              
      member_address: currentperson.address,
      member_address2: currentperson.address2,
      member_zip: currentperson.zip,
      member_city: currentperson.city,  
      member_professionaldesc: currentperson.professionaldesc, 
      member_im: currentperson.im,
      member_email: currentperson.email, 
      member_phone: currentperson.phone,
      member_avatarurl: currentperson.avatarurl
    }
  }

  onOrganizationCreateSubmit(){
    this.orgaddservice.addOrg(this.organization).pipe(untilDestroyed(this)).subscribe(org => {
      //console.log('org service return', org);
      this.organization.organizationId = org.organizationId;
      if(SessionHelper.getPersonOrgs()){
        var orglist:OrgAddOrganization[] = JSON.parse(SessionHelper.getPersonOrgs());
        orglist.push(this.organization);
        SessionHelper.setPersonOrgs(JSON.stringify(orglist));
      }else{
        SessionHelper.setPersonOrgs(JSON.stringify([this.organization]));
      }
      SessionHelper.setChoosenOrg(org.organizationId);
      this.router.navigate(['/portal']);
    },(error)=>{
      alert('ERROR: '+error.error);
    });
  }

}
